import useInternalContext from './useInternalContext';
export default function useStyleToClassName() {
  var _useInternalContext = useInternalContext(),
    styleToClassName = _useInternalContext.styleToClassName;
  return styleToClassName;
}